import React from 'react';
import '../styles/Faq.css';

const Breadcrumbs = ({ items = [], separator = 'chevron' }) => {
  const safeItems = items.length ? items : [{ label: 'Home', href: '/' }];
  return (
    <div className="position" role="navigation" aria-label="Breadcrumb">
      <div className="w135">
        <div className="flex f-jsb">
          <div className="lf wjx-breadcrumbs">
            {safeItems.map((item, idx) => (
              <React.Fragment key={`${item.href || item.label}-${idx}`}>
                {idx > 0 && (
                  separator === 'slash' ? (
                    <span className="crumb-sep">/</span>
                  ) : (
                    <span className="crumb-svg-sep" aria-hidden>
                      <svg viewBox="0 0 1024 1024" width="12" height="12" focusable="false" aria-hidden="true">
                        <path d="M340.864 149.312a30.592 30.592 0 000 42.752L652.736 512 340.864 831.872a30.592 30.592 0 000 42.752 29.12 29.12 0 0041.728 0L714.24 534.336a32 32 0 000-44.672L382.592 149.376a29.12 29.12 0 00-41.728 0z"></path>
                      </svg>
                    </span>
                  )
                )}
                {item.href ? (
                  <a href={item.href} onDragStart={(e) => e.preventDefault()}>{item.label}</a>
                ) : (
                  <span>{item.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;


